// extracted by mini-css-extract-plugin
module.exports = {"themeSwitcher":"ThemeSwitcher_themeSwitcher__JepzO"};